/* GLLF: combine Hardiness Zone filter values (5a + 5b → "Zone 5"). Ticking a zone selects both halves; several zones
   can be selected at once. Built by cloning a real filter row so the theme's checkbox styling and behaviour are kept. */
(() => {
  "use strict";
  const ZONE = /^\s*(\d{1,2})\s*([ab])\b/i;
  const labelEl = (input) => input.closest("label") || (input.id && document.querySelector(`label[for="${CSS.escape(input.id)}"]`)) || input.parentElement;
  const rowOf = (input) => input.closest("li") || input.closest(".facets__item, .mobile-facets__item") || labelEl(input);
  let seq = 0;
  function enhance() {
    const inputs = [...document.querySelectorAll('input[type="checkbox"][name*="hardiness"]:not([data-gz])')];
    if (!inputs.length) return;
    const lists = new Map();
    for (const input of inputs) { input.dataset.gz = "1"; const row = rowOf(input), list = row?.parentElement; if (list) (lists.get(list) || lists.set(list, []).get(list)).push({ input, row }); }
    for (const [list, members] of lists) {
      const zones = new Map();
      for (const m of members) { const hit = (labelEl(m.input)?.textContent || "").match(ZONE); if (!hit) continue; const n = Number(hit[1]); (zones.get(n) || zones.set(n, []).get(n)).push({ ...m, half: hit[2].toLowerCase() }); }
      if (!zones.size) continue;
      const anchor = members[0].row;
      for (const n of [...zones.keys()].sort((a, b) => a - b)) {
        const group = zones.get(n), sample = group[0].row;
        const row = sample.cloneNode(true);
        row.classList.add("gllf-zone-row"); row.removeAttribute("id"); row.hidden = false; row.style.display = "";
        const box = row.querySelector('input[type="checkbox"]');
        if (!box) continue;
        const id = `gllf-zone-${n}-${seq++}`, oldId = box.id;
        box.removeAttribute("name"); box.removeAttribute("value"); box.id = id; box.checked = group.every(({ input }) => input.checked); box.disabled = group.every(({ input }) => input.disabled);
        row.querySelectorAll(`label[for="${CSS.escape(oldId || "none")}"]`).forEach((l) => l.setAttribute("for", id));
        const text = row.querySelector(".facet-checkbox__text, .facets__label, span, label") || row;
        const holder = text.tagName === "LABEL" ? text : text;
        holder.innerHTML = holder.innerHTML.replace(/([^<>]*\b\d{1,2}[ab]\b[^<>]*)/, "") || "";
        const caption = document.createElement("span");
        caption.className = "gllf-zone-caption";
        caption.innerHTML = `<b>Zone ${n}</b> <small>${group.map((g) => `${n}${g.half}`).sort().join(" / ")}</small>`;
        holder.appendChild(caption);
        group.forEach(({ row: r }) => { r.hidden = true; r.style.display = "none"; });
        list.insertBefore(row, anchor);
        box.addEventListener("change", () => {
          const on = box.checked; let last = null;
          group.forEach(({ input }) => { if (!input.disabled && input.checked !== on) { input.checked = on; last = input; } });
          if (last) { last.dispatchEvent(new Event("input", { bubbles: true })); last.dispatchEvent(new Event("change", { bubbles: true })); }
        });
      }
    }
  }
  let t; const soon = () => { clearTimeout(t); t = setTimeout(enhance, 80); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", enhance); else enhance();
  new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
})();
